import { FlexRow } from '@make-software/cspr-design';
import styled from 'styled-components';
import { FlexColumn, SubtitleText } from '@make-software/cspr-design';
import React from 'react';

const Container = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    textAlign: 'center',
    width: '100%',
    height: '300px'
  })
);

interface ModalTextProps {
  icon?: React.ReactElement;
  text: string;
}

export const TextModal = ({ icon, text }: ModalTextProps) => {
  return (
    <>
      <FlexRow justify={'center'}>
        <Container itemsSpacing={54} align={'center'} justify={'center'}>
          {icon}
          <SubtitleText size={1} scale="lg">
            {text}
          </SubtitleText>
        </Container>
      </FlexRow>
    </>
  );
};
